import moment from "moment";
const handleTimeStampToDateTime = (
  timeStamp,
  format = "YYYY-MM-DD HH:mm:ss"
) => {
  return moment(timeStamp).format(format);
};
export { handleTimeStampToDateTime };
